import debounce from 'lodash/debounce';

const titleContext = { entityName: null, action: null, entityType: null };
let _router = null;

export function initTitleContext (router) {
    _router = router;
}

export const scheduleApplyTitle = debounce(() => {
    if (_router?.currentRoute?.value) {
        applyRouteTitle(_router.currentRoute.value);
    }
}, 10);

export function setTitleContext (context = {}) {
    if ('entityName' in context) titleContext.entityName = context.entityName;
    if ('action' in context) titleContext.action = context.action;
    if ('entityType' in context) titleContext.entityType = context.entityType;
    scheduleApplyTitle();
}

export function clearTitleContext () {
    titleContext.entityName = null;
    titleContext.action = null;
    titleContext.entityType = null;
}

export function applyRouteTitle (to) {
    const { entityName, action, entityType: contextEntityType } = titleContext;
    const pageTitle = to.meta?.title ?? '';
    const entityType = contextEntityType ?? pageTitle;
    const base = entityName && entityType
        ? `${entityName} - ${entityType}`
        : (entityName ?? entityType ?? '');
    const titlePart = action ? `${action} - ${base}` : base;
    const content = titlePart || pageTitle;

    document.title = content;
}
